import {View} from 'react-native';
import * as React from 'react';
import {useTheme} from '../../theme';
import {Props} from './model';
import {Text} from '../text';
import {useStyles} from '../../hooks/styles';

export const OrDelimiter = (props: Props) => {
  const theme = useTheme();
  const styles = useStyles(
    () => ({
      textWrapper: {
        position: 'absolute',
        top: -8,
        height: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        left: 0,
        right: 0,
      },
      text: {
        paddingHorizontal: 19,
        backgroundColor: theme.color.whiteTextColor,
        color: theme.color.labelText,
      },
    }),
    [theme],
  );

  return (
    <View
      style={{
        marginTop: props.marginTop ?? 30,
        marginBottom: props.marginBottom ?? 30,
        ...theme.hr,
      }}>
      <View style={styles.textWrapper}>
        <Text style={styles.text} type='label'>
          или
        </Text>
      </View>
    </View>
  );
};
